import account from 'Store/UserAccount/account'
import address from 'Store/UserAccount/address'
import review from 'Store/UserAccount/review'

export default {
  namespaced: true,

  modules: {
    account,
    address,
    review
  }
}